import type { FC, ReactElement } from 'react';

import { ButtonVariant } from '../../controls/button/Button';

import { BlockingModalActionButton, BlockingModalContent } from './BlockingModalContent';

export const ConnectionLostConnected: FC = (): ReactElement => {
  const action: BlockingModalActionButton[] = [
    {
      tk: 'OK',
      type: ButtonVariant.ACCENT,
      click: (): void => {
        connectionLostOnClose();
      },
    },
  ];

  return <BlockingModalContent messageTk="NO_INTERNET" actions={action} />;
};

export const connectionLostOnClose = (): void => {
  location.reload();
};
